.container {
  display: grid;
  gap: 32px;
  max-width: 840px;
  padding-block: 16px;
  margin-inline: auto;

  @media screen and (width >= 600px) {
    padding-block: 24px;
  }

  @media screen and (width >= 769px) {
    gap: 48px;
    padding-block: 62px;
  }
}

.overview {
  display: grid;
  gap: 32px;

  @media screen and (width >= 769px) {
    gap: 48px;
  }
}

.form {
  display: grid;
  gap: 48px;
  justify-content: center;
}

.formatLocalizationMenuContainer {
  display: flex;
  justify-content: flex-end;
}

.formSections {
  display: grid;
  gap: 32px;
}

.buttonContainer {
  display: flex;
  justify-content: center;
}
